const source = {
  listings: 'listings_page',
  checkout: 'checkout_page',
  suites: 'suites_page',
  properties: 'properties_page',
  contactUs: 'account_contact_us_page',
  myBookings: 'my_bookings_page',
  myMembership: 'my_membership_page',
  accountProfile: 'profile_page',
  accountMobile: 'account_mobile_page',
  ourLocations: 'our_locations_page',
  newsletter: 'newsletter_page'
};

const sourceElement = {
  footerContactItem: 'footer_contact_menu_item',
  footerHelpAndFaqItem: 'footer_help_and_faq_menu_item',
  headerHowItWorksMenu: 'header_how_it_works_menu',
  accountContactUsPageLink: 'account_contact_us_page_link',
  accountMobileHelpMenuLink: 'account_mobile_nav_help_link'
};

type SourceKeys = keyof typeof source;
type SourceElementKeys = keyof typeof sourceElement;

interface TrackingEvents {
  source: Record<SourceKeys, string>;
  sourceElement: Record<SourceElementKeys, string>;
}

export const helpCenterEvents: TrackingEvents = {
  source,
  sourceElement
};
